import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate, NavLink, Link, Navigate } from "react-router-dom";
import { BgLoader } from './ui';
import { IoIosArrowForward } from 'react-icons/io';
import { instance } from "./axios";
import { useStore } from "./state.js";
import { AiOutlineHome, AiOutlineStar, AiOutlineShoppingCart, AiOutlineClose } from "react-icons/ai";
import { Logout } from "./helper";
import { HiOutlineUserCircle } from "react-icons/hi";

import { IoMdArrowBack, IoMdCall } from "react-icons/io";
import { TbZoomCancel } from "react-icons/tb";
import { BsThreeDotsVertical } from "react-icons/bs";

import zustand from "zustand";


const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState({});
  const [squery, setQuery] = useState('');
  const [title, setTitle] = useState("");
  const zstate = useStore((state) => state.cart_count);
  const setZState = useStore((state) => state.setCount);

  const { auth, setAuth } = useStore((state) => state);
  let activeStyle = {
    textDecoration: "underline",
  };
  useEffect(() => {


    setState({ ...state, items: null })

  }, [location]);


  useEffect(() => {


    instance
      .get("/cust_web")
      .then(function (response) {
        setState({ ...state, ...response.data })
      })
      .catch(function (error) { })
      .then(function () { });

  }, []);




  return (
    <>
      {state.company ?
        <>
          <header className="navbar navbar-light sticky-top bg-white align-items-center d-flex shadow-sm py-2 px-3 mb-3">
            {location.pathname !== '/' && (
              <Link className="p-2 fs-1 lh-1 text-dark" to={-1}><IoMdArrowBack /></Link>
            )}
            <a className="navbar-brand me-0" href="#">
              {state.company.logo ?
                <img className="logo" src={state.company.logo} />
                : <div>{state.company.company}</div>}
            </a>

            <div className="flex-grow-1 col-9 ps-3">
              {location.pathname == '/' ? (
                <h1 className="mb-0 fs-3">{state.company.company}</h1>
              ) : (
                <h1 className="mb-0 fs-3">{title}</h1>
              )}
            </div>
          </header>


          <div className="container-fluid">
            <div className="row">


              <main className="p-2">
                <section className="content d-inline-block w-100">
                  <div className="container-fluid">
                    <Outlet context={[state, setTitle]} />
                  </div>
                </section>
              </main>

              <div className="fixed-bottom bg-white border-top appbottom py-2">
                <div className="d-flex align-items-center">
                  <HiOutlineUserCircle className="fs-1 text-muted"/>
                  <div className="flex-grow-1 ms-2 d-flex"><span className="text-truncate text-muted">{state.company.name}</span></div>
                  <div>
                    <div className="dropdown">
                      <button className="btn btn-light" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <BsThreeDotsVertical />
                      </button>
                      <ul className="dropdown-menu">
                        {state.multi == 1 && <li><button onClick={()=>navigate("/switch-account")} className="dropdown-item">Switch Account</button></li>}
                        <li><button className="dropdown-item" onClick={()=>Logout()} >Logout</button></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
        : <BgLoader />}
    </>
  );
};

export default Layout;
